export default "__VITE_ASSET__CfOUJzDR__"